import { render } from "./LocalizationConfiguration.vue?vue&type=template&id=63bfd24d&scoped=true"
import script from "./LocalizationConfiguration.vue?vue&type=script&lang=js"
export * from "./LocalizationConfiguration.vue?vue&type=script&lang=js"

import "./LocalizationConfiguration.vue?vue&type=style&index=0&id=63bfd24d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bfd24d"]])

export default __exports__